import {
  Box,
  Button,
  Checkbox,
  Combobox,
  ComboboxItem,
  Grid,
  Group,
  LoadingOverlay,
  Radio,
  rem,
  ScrollArea,
  Select,
  Table,
  TagsInput,
  TagsInputProps,
  Textarea,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconEye, IconWindow } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import Repository from "../../_base/helper/HttpHelper";

import { MessageResponse } from "../../model/MessageResponse";
import { repositorySign } from "../../_base/_const/_constVar";
import { DateInput, DateInputProps } from "@mantine/dates";
import { SelectListItemBase } from "../../_base/model/_base/SelectListItemBase";
import dayjs from "dayjs";
import { RoleModel } from "../../model/RoleModel";
import { _sideNavData } from "../../_setup/navdata/_sideNavData";
import { join } from "path";
import { LinksGroupProps } from "../../_base/model/_base/LinksGroupProps";

const RolesEditView = function ({
  id,
  onLoad,
}: {
  id: number;
  onLoad: () => Promise<void>;
}) {
  const entity: RoleModel = {
    id: 0,
    code: "",
    name: "",
    tsv: "",
    listrolenew: "",
  };
  const form = useForm<RoleModel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    //   validate: _validateUserMasterModelValidator,
  });

  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [value, setValue] = useState<Date | null>(null);
  const apiCreate = async (data: RoleModel) => {
    data.listrolenew = valueInventory.join(",");
    console.log(data);
    open();
    data.id = id;
    let urlCreate = `/api/v1/role/update`;
    const callapi = await repositorySign.post(urlCreate, data);
    if (callapi)
      if (callapi?.success) {
        await onLoad();
        NotificationExtension.Success("Thao tác thành công !");
        modals.closeAll();
      } else if (callapi != null)
        NotificationExtension.Fails("Thao tác thất bại !");
    close();
  };

  useEffect(() => {
    if (id) callApiGetData();
  }, [id]);

  const callApiGetData = async () => {
    open();

    let urlCreate = `/api/v1/role/update?id=` + id;
    const callapi = await repositorySign.get<MessageResponse<RoleModel>>(
      urlCreate
    );
    if (callapi) {
      const dataApi = callapi?.data;
      if (dataApi != null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
        if (dataApi.listrolenew != null) {
          const data = dataApi.listrolenew.split(",");
          setValueInventory(data);
        }
      }
      close();
    } else {
      modals.closeAll();
    }
  };

  const [valueInventory, setValueInventory] = useState<string[]>([]);

  const flattenLinks = (
    links: LinksGroupProps[]
  ): { label: string; code: string }[] => {
    const result: { label: string; code: string }[] = [];
    const seenCodes = new Set<string>(); // Tập hợp để lưu các code đã thêm

    const traverse = (items: any[]) => {
      for (const item of items) {
        if (!seenCodes.has(item.code)) {
          // Kiểm tra nếu code chưa được thêm
          result.push({ label: item.label, code: item.code });
          seenCodes.add(item.code); // Đánh dấu code đã xuất hiện
        }
        if (item.links) {
          traverse(item.links); // Đệ quy nếu tồn tại nhánh con
        }
      }
    };

    traverse(links);
    return result;
  };

  const rows = flattenLinks(_sideNavData).map((element) => (
    <Table.Tr key={element.code}>
      <Table.Td>{element.label}</Table.Td>
      <Table.Td>{element.code}</Table.Td>
      <Table.Td>
        {" "}
        <Checkbox
          key={element.code}
          checked={valueInventory.findIndex((x) => x === element.code) > -1}
          onChange={(e) => {
            if (e.target.checked) {
              setValueInventory([...valueInventory, element.code]);
            } else {
              setValueInventory(
                valueInventory.filter((x) => x !== element.code)
              );
            }
          }}
        />
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <>
      <Box
        component="form"
        onSubmit={form.onSubmit(async (e: RoleModel) => {
          await apiCreate(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Box className="flex-none" component="form" mx="auto">
          <Grid>
            <Grid.Col span={{ base: 12, xs: 6 }}>
              <TextInput
                key={form.key("code")}
                label="Tên vai trò: "
                placeholder="Nhập..."
                withAsterisk
                //   disabled
                {...form.getInputProps("name")}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, xs: 6 }}>
              <TextInput
                key={form.key("fullname")}
                disabled
                label="Mã vai trò: "
                placeholder="Nhập..."
                withAsterisk
                {...form.getInputProps("code")}
              />
            </Grid.Col>
          </Grid>

          <Grid>
            <Grid.Col span={12}>
              <Table stickyHeader stickyHeaderOffset={60}>
                <Table.Thead>
                  <Table.Tr>
                    <Table.Th>Tên tính năng</Table.Th>
                    <Table.Th>Mã tính năng</Table.Th>
                    <Table.Th>Có quyền</Table.Th>
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody>{rows}</Table.Tbody>
              </Table>
            </Grid.Col>
          </Grid>
        </Box>
        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};

export default RolesEditView;
